var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.AnalyticsSubPage,{attrs:{"title":"Rewards Analytics","icon":"gift","css-class":"analytics-rewards","default-label":"Rewards","get-sheet-config":_setup.getSheetConfig}},[_c(_setup.RewardsMetrics,{ref:"metricsRef"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }